// @ts-nocheck

export const localeCodes =  [
  "en",
  "fr",
  "id"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_4d6e8c5f",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_97f92234",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  id: [
    {
      key: "locale_id_46json_5028df0d",
      load: () => Promise.resolve({}),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    language: "en",
    name: "English",
    isCatchallLocale: true,
    defaultTid: "esv2001",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "fr",
    language: "fr",
    name: "Français",
    defaultTid: "neg1979",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "id",
    language: "id",
    name: "Bahasa Indonesia",
    defaultTid: "esv2001",
    domains: [],
    defaultForDomains: []
  }
]

